import { type ComponentProps } from 'react';

import { getDefaultClassNames } from 'react-day-picker';

import { buttonVariants } from '@/components/ui/button';
import { type Calendar } from '@/components/ui/calendar';
import { cn } from '@/lib/utils';

const DEFAULTS = getDefaultClassNames();

export const DATE_RANGE_CALENDAR_CLASS_NAMES: ComponentProps<typeof Calendar>['classNames'] = {
  month: 'flex w-65 flex-col items-start gap-1',
  nav: 'absolute inset-x-0 top-0 flex items-center justify-between px-1.5 py-1',
  month_caption: 'flex h-10 w-full items-center justify-center',
  caption_label: 'text-sm leading-6 font-medium text-foreground select-none',
  button_previous: cn(
    buttonVariants({ variant: 'ghost-neutral', size: 'icon-sm' }),
    'size-8 rounded-lg p-2 select-none aria-disabled:cursor-not-allowed aria-disabled:opacity-50 aria-disabled:hover:bg-transparent',
    DEFAULTS.button_previous
  ),
  button_next: cn(
    buttonVariants({ variant: 'ghost-neutral', size: 'icon-sm' }),
    'size-8 rounded-lg p-2 select-none aria-disabled:cursor-not-allowed aria-disabled:opacity-50 aria-disabled:hover:bg-transparent',
    DEFAULTS.button_next
  ),
  disabled: '',
  weekday:
    'flex flex-1 flex-col items-center justify-center gap-2.5 rounded-lg text-xs leading-5 font-normal text-muted-foreground select-none',
  month_grid: 'w-full border-collapse px-1 pb-1.5',
  weeks: 'flex flex-col items-start gap-0',
  today: 'rounded-lg',
  day: cn(
    'group/day relative aspect-square h-full w-full p-0 text-center select-none',
    DEFAULTS.day
  ),
  range_start: 'rounded-l-lg bg-muted last:rounded-r-lg',
  range_middle: 'rounded-none bg-muted first:rounded-l-lg last:rounded-r-lg',
  range_end: 'rounded-r-lg bg-muted first:rounded-l-lg',
};
